export interface Season {
    id: string;
    name: string;
    startAt: string;
    endAt: string;
    current: boolean;
    year: string;
}

export const SeasonFormDefault: Season = {
    id: "",
    name: "",
    current: false,
    startAt: "",
    endAt: "",
    year: "",
}